const Analytics = {}

Analytics.Log = (data) => {
    console.log('Analytics service log: ', data)
}

export default Analytics;